exports = module.exports = require("../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".angucomplete-holder{position:relative}.angucomplete-dropdown{border:1px solid #ececec;border-radius:2px;width:250px;padding:6px;cursor:pointer;z-index:9999;position:absolute;margin-top:-6px;background-color:#fff}.angucomplete-searching{color:#acacac;font-size:14px}.angucomplete-description{font-size:14px}.angucomplete-row{padding:5px;color:#000;margin-bottom:4px;clear:both}.angucomplete-selected-row{background-color:#add8e6;color:#fff}.angucomplete-image-holder{padding-top:2px;float:left;margin-right:10px;margin-left:5px}.angucomplete-image{height:34px;width:34px;border-radius:50%;border:1px solid #ececec}.angucomplete-image-default{background-position:50%;background-size:contain;height:34px;width:34px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/angucomplete-alt/angucomplete-alt.css
// module id = 344
// module chunks = 1